import { render, staticRenderFns } from "./CustomerInvoiceCreate.vue?vue&type=template&id=4f3bfc3d"
import script from "./CustomerInvoiceCreate.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports